/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Sync_Col_Portal_StateInputs */

const cs_portals_sync_col_portal_state = /** @type {(inputs: Portals_Sync_Col_Portal_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na portálu`)
};

const en_portals_sync_col_portal_state = /** @type {(inputs: Portals_Sync_Col_Portal_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On portal`)
};

/**
* | output |
* | --- |
* | "On portal" |
*
* @param {Portals_Sync_Col_Portal_StateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_col_portal_state = /** @type {((inputs?: Portals_Sync_Col_Portal_StateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_Col_Portal_StateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_col_portal_state(inputs)
	return cs_portals_sync_col_portal_state(inputs)
});